@if (isDesktop) {
  <div class="header-container">
    @if (inviteMode === 'choice') {
      <button
        appButton
        name="back"
        location="share-gallery-collaborators"
        color="simple"
        height="1"
        [iconButton]="true"
        shape="round"
        (click)="cancelInviteChoice()"
      >
        <app-svg src="/assets/icons/arrow-left.svg"></app-svg>
      </button>
    }

    <h3 class="mode-title">
      @if (inviteMode === 'choice') {
        Invite Collaborators
      } @else {
        @if (accessLevel === 'edit') {
          Invite Collaborators
        } @else {
          Collaborators
        }
      }
    </h3>
  </div>
}
@if (loading()) {
  <app-loading-indicator class="main-loading"></app-loading-indicator>
} @else {
  @if (inviteMode === 'choice') {
    <div class="emails-list">
      <div class="email-list-inner">
        @for (email of nonMemberEmails | slice: 0 : (nonMemberEmails.length > 4 ? 3 : 4); track email) {
          <div class="email">
            {{ email }}
          </div>
        }
        @if (nonMemberEmails.length > 4) {
          <div class="email extra-emails">+{{ nonMemberEmails.length - 3 }}</div>
        }
      </div>
    </div>
    <div class="type-selection-container">
      <div class="type-selection-item" [class.active]="inviteType() === 'gallery'" (click)="inviteType.set('gallery')">
        <div class="selection-icon">
          <app-svg src="/assets/icons/user-globe.svg"></app-svg>
        </div>
        <div class="selection-content">
          <h3>
            @if (emailsCached.length !== 1) {
              Add as Guests
            } @else {
              Add as Guest
            }
          </h3>
          <p class="standard-text">Guests can only access galleries they’re invited to.</p>
        </div>
      </div>
      <div class="type-selection-item" [class.active]="inviteType() === 'team'" (click)="inviteType.set('team')">
        <div class="selection-icon">
          <app-svg src="/assets/icons/user-company.svg"></app-svg>
        </div>
        <div class="selection-content">
          <h3>
            @if (emailsCached.length !== 1) {
              Add as Members
            } @else {
              Add as Member
            }
          </h3>
          <p class="standard-text">Team members can create and discover galleries.</p>
        </div>
      </div>
    </div>
    <div class="invite-mode-footer">
      <p class="standard-text small invite-info">
        @if (inviteType() === 'gallery') {
          <b
            >{{ nonMemberEmails.length }}
            @if (nonMemberEmails.length !== 1) {
              Collaborators
            } @else {
              Collaborator
            }
          </b>
          will be invited as external guests for free.
        }
        @if (inviteType() === 'team') {
          <app-team-invite-charge-text></app-team-invite-charge-text>
        }
      </p>
      <div class="spacer"></div>
      <button
        appButton
        name="add-people"
        location="share-gallery-collaborators"
        height="3"
        heightMobile="2"
        (click)="sendInvitesWithChoice()"
        color="primary"
        width="160"
        shape="round"
        class="done-button"
        data-test-id="add-people"
      >
        <span [class.hidden-text]="sendingInvites">
          {{ getFinalCta() }}
        </span>
        @if (sendingInvites) {
          <app-loading-indicator color="white" size="small" class="button-loading-indicator"> </app-loading-indicator>
        }
      </button>
    </div>
  } @else {
    @if (!isItemGuest && accessLevel === 'edit') {
      <app-emails-entry-field
        #emailsEntryField
        (onChange)="onEmailChange($event)"
        [validationMethod]="validateEmail()"
        [validationErrorMessageMethod]="getEmailErrorMessage()"
        (onBlur)="onBlur()"
        (onFocus)="onFocus()"
        [autoCompleteMethod]="autoComplete()"
        [customPlaceholder]="'Enter name or email to invite...'"
      >
        @if (inviteMode === 'email') {
          <app-gallery-share-context
            class="email-field-access-context"
            [accessLevel]="inviteAccessLevel"
            [centerVertically]="false"
            [accessLevels]="inviteAccessLevels"
            (onChange)="inviteAccessLevel = $event"
            [type]="isGallery ? 'gallery' : 'folder'"
            [mode]="'invite-field'"
          ></app-gallery-share-context>
        }
      </app-emails-entry-field>
    }
    @if (!inviteMode) {
      <div class="access-list-container">
        <div class="access-list" [class.padding-bottom]="!itemMembers.length && !pendingItemMembers.length">
          @if (!isItemGuest) {
            <div class="access-list-item">
              <div
                class="access-list-icon"
                [class.primary]="tenantAccessLevel !== 'no_access'"
                [class.red]="tenantAccessLevel === 'no_access'"
              >
                <app-svg src="/assets/icons/building.svg"></app-svg>
              </div>
              <div class="access-list-info">
                <div class="info-main">
                  @if (isDesktop) {
                    Everyone at
                  }
                  <b
                    class="tenant-name"
                    [class.clickable]="userGroups.length && accessLevel === 'edit'"
                    (click)="userGroups.length && userGroupMenu.open()"
                    >{{ tenant.name }}
                    @if (userGroups.length && accessLevel === 'edit') {
                      <app-svg src="/assets/icons/12/chevron-down.svg"></app-svg>
                    }
                  </b>
                  <app-context-menu
                    [options]="{ noSpacing: true }"
                    #userGroupMenu
                    (onToggle)="toggleUserGroupMenu($event)"
                  >
                    <div contextContent class="user-groups-dropdown">
                      <b>User Groups</b>
                      @for (group of userGroups; track group) {
                        <app-radio-button
                          [checkStyle]="'check'"
                          [checked]="itemUserGroupsMap[group.id]"
                          (click)="toggleUserGroup(group)"
                          [hasIcon]="true"
                          name="group-toggle"
                          spacing="2"
                          [fullWidth]="true"
                          location="share-gallery-collaborators"
                          class="user-group-dropdown-item"
                        >
                          <app-svg src="/assets/icons/team.svg"></app-svg>
                          <span class="group-name">{{ group.name }}</span>
                          <span class="user-count">({{ userGroupUsers[group.id]?.length }})</span>
                        </app-radio-button>
                      }
                    </div>
                  </app-context-menu>
                </div>
                <div class="info-extra">{{ memberCount }} People</div>
              </div>
              <div class="access-list-action">
                <app-gallery-share-context
                  [accessLevel]="tenantAccessLevel"
                  [accessLevels]="tenantAccessLevels"
                  (onChange)="changeTenantAccess($event)"
                  [disabled]="isItemGuest || accessLevel !== 'edit'"
                  [red]="tenantAccessLevel === 'no_access'"
                  data-test-id="tenant-access"
                  [mode]="'team'"
                  [type]="isGallery ? 'gallery' : 'folder'"
                >
                </app-gallery-share-context>
              </div>
            </div>
            @for (group of itemUserGroups; track group.id) {
              <div class="access-list-item">
                <div class="access-list-icon primary">
                  <app-svg src="/assets/icons/user-group.svg"></app-svg>
                </div>
                <div class="access-list-info">
                  <div class="info-main">
                    Everyone in <b class="tenant-name">{{ group['groupData'].name }}</b>
                  </div>
                  <div class="info-extra">{{ userGroupUsers[group.group]?.length }} People</div>
                </div>
                <div class="access-list-action">
                  <app-gallery-share-context
                    [accessLevel]="group.access"
                    [accessLevels]="groupAccessLevels"
                    (onChange)="changeGroupAccess(group, $event)"
                    [disabled]="isItemGuest || accessLevel !== 'edit'"
                    [mode]="'group'"
                    [type]="isGallery ? 'gallery' : 'folder'"
                  >
                  </app-gallery-share-context>
                </div>
              </div>
            }
          } @else {
            <div class="access-list-item">
              <div class="access-list-icon">
                <img src="/assets/icons/special/team-access.svg" alt="" />
              </div>
              <div class="access-list-info">
                <div class="info-main">Everyone at {{ tenant.name }}</div>
              </div>
              <div class="access-list-action">
                <app-gallery-share-context
                  [accessLevel]="tenantAccessLevel"
                  [accessLevels]="tenantAccessLevels"
                  (onChange)="changeTenantAccess($event)"
                  [disabled]="isItemGuest || accessLevel !== 'edit'"
                  [mode]="'team'"
                  [type]="isGallery ? 'gallery' : 'folder'"
                >
                </app-gallery-share-context>
              </div>
            </div>
          }
          @if (owner) {
            <div class="access-list-item" data-test-id="owner-access">
              <div class="access-list-icon">
                <app-avatar [user]="owner"></app-avatar>
              </div>
              <div class="access-list-info">
                <div class="info-main">
                  {{ owner.first_name || 'No name' }} {{ owner.last_name }}
                  @if (owner.id === state.user.id) {
                    <span> (You)</span>
                  }
                </div>
                <div class="info-extra">{{ owner['email'] }}</div>
              </div>
              <div class="access-list-action">
                <button
                  appButton
                  type="button"
                  name="owner-access-toggle"
                  location="share-gallery-collaborators"
                  color="simple-gray"
                  weight="bold"
                  height="1"
                  spacing="1"
                  [hasIcon]="true"
                  [disabled]="true"
                >
                  <span>Owner</span>
                  <app-svg src="/assets/icons/24/arrow-down.svg" size="-1"></app-svg>
                </button>
              </div>
            </div>
          }
          <!-- Gallery members -->
          @for (member of itemMembers; track member) {
            <div class="access-list-item">
              <div class="access-list-icon">
                <app-avatar [user]="$any(member.user)"></app-avatar>
              </div>
              <div class="access-list-info">
                <div class="info-main">
                  {{ member.user['first_name'] || 'No name' }} {{ member.user['last_name'] }}
                  @if (member.user['id'] === state.user.id) {
                    <span> (You)</span>
                  }
                  @if (memberIsGuest(member)) {
                    <app-badge icon="/assets/icons/16/guest.svg" color="grey-50">Guest</app-badge>
                  }
                </div>
                <div class="info-extra">{{ member.user['email'] }}</div>
              </div>
              <div class="access-list-action">
                <app-gallery-share-context
                  [accessLevel]="member.access"
                  [accessLevels]="getGalleryMemberAccessLevels(member)"
                  [mode]="'member'"
                  (onChange)="changeMemberAccess(member, $event)"
                  [disabled]="isItemGuest && member.user['id'] !== state.user.id"
                  [type]="isGallery ? 'gallery' : 'folder'"
                ></app-gallery-share-context>
              </div>
            </div>
          }
          <!-- Parent gallery members -->
          @for (member of parentItemMembers; track member) {
            <div class="access-list-item">
              <div class="access-list-icon">
                <app-avatar [user]="$any(member.user)"></app-avatar>
              </div>
              <div class="access-list-info">
                <div class="info-main">
                  {{ member.user['first_name'] || 'No name' }} {{ member.user['last_name'] }}
                  @if (member.user['id'] === state.user.id) {
                    <span> (You)</span>
                  }
                  @if (memberIsGuest(member)) {
                    <app-badge icon="/assets/icons/16/guest.svg" color="grey-50">Guest</app-badge>
                  }
                </div>
                <div class="info-extra">{{ member.user['email'] }}</div>
              </div>
              <div class="access-list-action">
                <app-gallery-share-context
                  [accessLevel]="member.access"
                  [accessLevels]="member.user['id'] === state.user.id ? memberMeAccessLevels : memberAccessLevels"
                  [mode]="'member'"
                  (onChange)="changeMemberAccess(member, $event)"
                  [disabled]="true"
                  [type]="isGallery ? 'gallery' : 'folder'"
                >
                </app-gallery-share-context>
              </div>
            </div>
          }
          <!-- Pending gallery members -->
          @for (member of pendingItemMembers; track member) {
            <div class="access-list-item">
              <div class="access-list-icon pending">
                {{ member.email[0] | capitalize }}
              </div>
              <div class="access-list-info">
                <div class="info-main">
                  <span>Pending Invite</span>
                  <app-badge icon="/assets/icons/16/guest.svg" color="grey-50">Guest</app-badge>
                </div>
                <div class="info-extra">{{ member.email }}</div>
              </div>
              <div class="access-list-action">
                <app-gallery-share-context
                  [accessLevel]="member.access"
                  [accessLevels]="['remove']"
                  [mode]="'member-invite'"
                  (onChange)="changePendingMemberAccess(member, $event)"
                  [type]="isGallery ? 'gallery' : 'folder'"
                >
                </app-gallery-share-context>
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (!inviteMode && !itemMembers.length && !pendingItemMembers.length && isDesktop) {
      <div class="invite-info-message">
        <div class="invite-info-icon-container">
          <app-svg src="/assets/icons/team.svg" size="0-5"></app-svg>
        </div>
        <p class="standard-text">
          Manage access for team members and invite external guests for free.
          <a href="https://help.picflow.com/en/articles/7019139" target="_blank" class="primary-link">Learn more</a>
        </p>
      </div>
    }
    @if (inviteMode && !autoCompleteMode) {
      <form [formGroup]="messageForm">
        <div class="message-container">
          <label for="do-notify" class="switch-container">
            <app-switch>
              <input type="checkbox" id="do-notify" formControlName="notify" (ngModelChange)="changeNotifyPeople()" />
              <label for="do-notify" data-test-id="do-notify"></label>
            </app-switch>
            <span>Notify People</span>
          </label>
          @if (messageForm.value.notify) {
            <app-input-field [control]="messageForm.controls.message" [noLabel]="true">
              <textarea
                formControlName="message"
                placeholder="Add message... (optional)"
                (ngModelChange)="onMessageChange()"
              ></textarea>
            </app-input-field>
          }
          @if (!messageForm.value.notify) {
            <div class="no-textarea-placeholder"></div>
          }
        </div>
        <div class="invite-mode-footer">
          <p class="standard-text small invite-info">
            People new to Picflow will be invited to create an account.
            <a href="https://help.picflow.com/en/articles/7019139" target="_blank" class="primary-link">Learn more</a>
          </p>
          <div class="spacer"></div>
          <button
            appButton
            name="add-people"
            location="share-gallery-collaborators"
            height="3"
            heightMobile="2"
            (click)="continue()"
            color="primary"
            width="160"
            shape="round"
            class="done-button"
            data-test-id="add-people"
          >
            <span [class.hidden-text]="sendingInvites">
              @if (canInviteToTeam()) {
                Continue
              } @else {
                {{ getFinalCta() }}
              }
            </span>
            @if (sendingInvites) {
              <app-loading-indicator color="white" size="small" class="button-loading-indicator">
              </app-loading-indicator>
            }
          </button>
        </div>
      </form>
    }
    @if (inviteMode && autoCompleteMode) {
      <div class="auto-complete">
        @for (member of autoCompleteResults; track member) {
          <div class="access-list-item clickable" (pointerdown)="setValue(member.email)">
            <div class="access-list-icon" [class.pending]="member.isInvite">
              @if (!member.isInvite) {
                <app-avatar [user]="$any(member)"></app-avatar>
              }
              @if (member.isInvite) {
                {{ member.email[0] | capitalize }}
              }
            </div>
            <div class="access-list-info">
              <div class="info-main">
                @if (!member.isInvite) {
                  {{ member.first_name || 'No name' }} {{ member.last_name }}
                }
                @if (member.isInvite) {
                  Pending Invite
                }
                @if (member.id === state.user.id) {
                  <span>(You)</span>
                }
              </div>
              <div class="info-extra">{{ member.email }}</div>
            </div>
          </div>
        }
      </div>
    }
  }
}
